import { render, staticRenderFns } from "./ConfigMailHeader.vue?vue&type=template&id=78a953e1&scoped=true&"
import script from "./ConfigMailHeader.vue?vue&type=script&lang=js&"
export * from "./ConfigMailHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMailHeader.vue?vue&type=style&index=0&id=78a953e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a953e1",
  null
  
)

export default component.exports